import React from "react";
import StayTouch from "../../layout/StayTouch";
import layoutWrapper from "../../components/Hoc/layoutWrapper";
import SignUpBanner from "../login/SignUpBanner";
import FaqBanner from "./FaqBanner";
import FaqContent from "./FaqContent";
class Faq extends React.Component {
  render() {
    return (
      <div>
        <FaqBanner />
        <FaqContent />
        <SignUpBanner />
        <StayTouch />
      </div>
    );
  }
}

export default layoutWrapper(Faq);



// WEBPACK FOOTER //
// ./src/pages/faq/index.js